"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSlice = exports.tokenListSlice = exports.initThunk = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const dist_1 = require("types/dist");
const Module_1 = require("./Module");
const ApiClient_1 = require("../clients/ApiClient");
const FLAG = { init: false };
exports.initThunk = toolkit_1.createAsyncThunk('init/init', async (payload, ctx) => {
    if (FLAG.init) {
        console.log('ALREADY INIT');
        return;
    }
    FLAG.init = true;
    const container = await dist_1.IocModule.init();
    await container.registerModule(new Module_1.CommonModule(payload.apiBaseUrl));
    await container.registerModule(payload.module);
    const api = container.get(ApiClient_1.ApiClient);
    api.tokenList().then(list => ctx.dispatch(exports.tokenListSlice.actions.listLoaded({ list })));
    return 'SUCCESS';
});
exports.tokenListSlice = toolkit_1.createSlice({
    name: 'tokenList',
    initialState: {
        list: [],
    },
    reducers: {
        listLoaded: (state, action) => {
            state.list = action.payload.list;
        }
    }
});
exports.initSlice = toolkit_1.createSlice({
    name: 'init',
    initialState: {
        waiting: false,
        initialized: false,
    },
    reducers: {},
    extraReducers: {
        [exports.initThunk.pending]: (state) => {
            state.waiting = true;
        },
        [exports.initThunk.fulfilled]: (state, action) => {
            console.log('PROMISE FULFILED', action);
            state.waiting = false;
            if (!action.payload) {
                return;
            }
            state.initialized = true;
        },
        [exports.initThunk.rejected]: (state, action) => {
            state.waiting = false;
            state.initialized = false;
            console.log('ERROR WAS ', action);
            const err = (action.payload || action.error);
            state.initError = err.message || err.toString();
        },
    },
});
//# sourceMappingURL=Initializer.js.map